/** 工單出庫 create／update 固定出庫類別「製造」（後端 payload；UI 不顯示）。 */
export const WORK_ORDER_OUTBOUND_DEFAULT_STOCK_ISSUE_CATEGORY_ID = (
  'ec9aea89-2b2b-4395-ab00-f887bc5fd4ab'
);
